import React from 'react';
import { IMatrixMessage } from '../../../client/message/types';

interface RoomAvatarMessageProps {
  message: IMatrixMessage;
  className?: string;
}

export const RoomAvatarMessage = ({ message, className = '' }: RoomAvatarMessageProps) => {
  const sender = message.sender;
  return (
    <div className={`room-avatar-message ${className}`} style={{ color: '#8e24aa', padding: '8px 0' }}>
      {sender ? `${sender} 修改了房间头像` : `房间头像已修改`}
    </div>
  );
}; 